/** @copyright 2026 UIED技术团队 @license MIT */
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import "./Storefront.css";
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
